/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';

function MatchesTopHeader({ setOrderBy, orderBy }) {
  return (
    <>
      <div className="col-12 col-md-7 d-flex align-items-center mb-4 mb-md-0 justify-content-center justify-content-md-start">
        <h3 className="heading-h3">SPELPROGRAM</h3>
      </div>
      <div className="col-12 col-md-5">
        <div className="tabs">
          <div className="row">
            <div className="col-6 pe-0">
              <div
                onClick={() => setOrderBy('round')}
                className={
                  orderBy === 'round'
                    ? 'tabs__item tabs__item--is-active text-uppercase'
                    : 'tabs__item text-uppercase'
                }
              >
                Omgång
              </div>
            </div>
            <div className="col-6 ps-0">
              <div
                onClick={() => setOrderBy('date')}
                className={
                  orderBy === 'date'
                    ? 'tabs__item tabs__item--is-active text-uppercase'
                    : 'tabs__item text-uppercase'
                }
              >
                Datum
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MatchesTopHeader;
